// src/stores/assets/KitsStore.js
import { defineStore } from 'pinia';

export const useKitsStore = defineStore('kits', {
  state: () => ({
    filters: {
      kit_code: '',
      item_name: '',
      status: '',
      unidade: '',
      setor: '',
      responsavel_interno: '',
    },
  }),

  actions: {
    setFilter(key, value) {
      if (Object.prototype.hasOwnProperty.call(this.filters, key)) {
        this.filters[key] = value;
      }
    },

    setFilters(newFilters) {
      this.filters = { ...this.filters, ...newFilters };
    },

    clearFilters() {
      this.filters = {
        kit_code: '',
        item_name: '',
        status: '',
        unidade: '',
        setor: '',
        responsavel_interno: '',
      };
    }
  },
  persist:true
});
